import { render, staticRenderFns } from "./liveEvents.vue?vue&type=template&id=2af06f24&scoped=true&"
import script from "./liveEvents.vue?vue&type=script&lang=js&"
export * from "./liveEvents.vue?vue&type=script&lang=js&"
import style0 from "./liveEvents.vue?vue&type=style&index=0&id=2af06f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af06f24",
  null
  
)

export default component.exports